<template>
  <div>
    <v-btn color="primary" class="ma-1" @click="save">Zapisz</v-btn>
    <v-tabs v-model="tab">
      <v-tab v-for="locale in locales" :key="locale.tag">
        {{ locale.tag }} - {{ locale.name }}
        <v-icon v-if="locale.enable" small class="ml-1" color="green"
          >fa fa-check</v-icon
        >
        <v-icon v-else class="ml-1" small>fa fa-times</v-icon>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="locale in locales" :key="locale.tag">
        <v-card>
          <v-card-text>
            <v-switch v-model="locale.enable" label="Czy włączony"></v-switch>
            <div v-if="locale.enable">
              <v-tabs v-model="insideTab">
                <v-tab
                  v-for="[key] in translationsByGroup(locale.translations)"
                  :key="key"
                  >{{ getNameByKey(key) }}</v-tab
                >
                <v-tab key="localizations">Localizacje</v-tab>
                <v-tab key="queues">Kolejki</v-tab>
                <v-tab key="operations">Operacje</v-tab>
              </v-tabs>
              <v-tabs-items v-model="insideTab">
                <v-tab-item
                  class="mt-3"
                  v-for="[key, value] in translationsByGroup(
                    locale.translations
                  )"
                  :key="key"
                >
                  <div v-for="item in value" :key="item.key">
                    <div v-if="item.inputType == 'Html'">
                      <label>{{ item.description }}</label>
                      <ckeditor
                        :config="editorConfig"
                        editorUrl="https://cdn.ckeditor.com/4.14.0/full-all/ckeditor.js"
                        v-model="item.value"
                      ></ckeditor>
                    </div>
                    <v-text-field
                      v-else
                      dense
                      v-model="item.value"
                      :label="item.description"
                    ></v-text-field>
                  </div>
                </v-tab-item>
                <v-tab-item key="localizations" class="mt-3">
                  <v-text-field
                    v-for="loc in locale.localizations"
                    dense
                    :key="loc.entityId"
                    v-model="loc.value"
                    :label="loc.entityName"
                  ></v-text-field>
                </v-tab-item>
                <v-tab-item key="queues" class="mt-3">
                  <v-text-field
                    v-for="queue in locale.queues"
                    dense
                    :key="queue.entityId"
                    v-model="queue.value"
                    :label="queue.entityName"
                  ></v-text-field>
                </v-tab-item>
                <v-tab-item key="operations" class="mt-3">
                  <v-text-field
                    v-for="operation in locale.operations"
                    dense
                    :key="operation.entityId"
                    v-model="operation.value"
                    :label="operation.entityName"
                  ></v-text-field>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import CKEditor from "ckeditor4-vue";
export default {
  components: {
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      locales: [],
      tab: 0,
      insideTab: 0,
      editorConfig: {
        height: 300,
        versionCheck: false,
      },
    };
  },
  computed: {
    companyId() {
      return this.$route.params.companyId;
    },
  },
  methods: {
    getNameByKey(key) {
      switch (key.toLowerCase()) {
        case "general": {
          return "Ogólny";
        }
        case "queue_names": {
          return "Kolejki";
        }
        case "operation_names": {
          return "Operacje";
        }
        case "property_names": {
          return "Dane";
        }
        case "header": {
          return "Nagłówek";
        }
        case "footer": {
          return "Stopka";
        }
        case "queuestatus": {
          return "Status kolejek";
        }
        case "validation": {
          return "Walidacje";
        }
        case "status": {
          return "Status rezerwacji";
        }
        case "property": {
          return "Dane rezerwacji";
        }
        case "template": {
          return "Nowy szablon";
        }
        default: {
          return key;
        }
      }
    },
    async save() {
      const { data } = await this.$http.post(
        "Locale/UpdateCompanyLocales",
        this.locales
      );
      console.log(data);
    },
    async getTranslations() {
      const { data } = await this.$http.get(
        "Locale/GetLocalesForCompany?companyId=" + this.companyId
      );
      this.locales = data;
    },
    groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    translationsByGroup(translations) {
      const entries = Object.entries(this.groupBy(translations, "group"));
      const templateIndex = entries.findIndex(([key]) => key.toLowerCase() === "template");
      if (templateIndex > 0) {
        entries.unshift(entries.splice(templateIndex, 1)[0]);
      }
      return entries;
    },
  },
  async mounted() {
    await this.getTranslations();
  },
};
</script>